/**
 * MarketTrendsChart CSS Styles
 *
 * CSS-in-JS styles injected once on first component instantiation.
 * Scoped via .sm-market-trends prefix, mirrors SalesChart's styles.ts
 * injection pattern.
 */
let stylesInjected = false;
const STYLES = `
.sm-market-trends {
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.sm-market-trends-segment-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.sm-market-trends-segment-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.sm-market-trends-segment-label {
  font-size: 0.8rem;
  font-weight: 500;
  color: #6b7280;
}

.sm-market-trends-segment-btns {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.sm-market-trends-help-btn {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid #d1d5db;
  background: white;
  color: #6b7280;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-family: inherit;
  transition: all 0.15s ease;
}

.sm-market-trends-help-btn:hover,
.sm-market-trends-help-btn[aria-expanded="true"] {
  border-color: #111827;
  color: #111827;
}

.sm-market-trends-help-panel {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 10px;
}

.sm-market-trends-help-overall {
  margin: 0 0 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.8rem;
  color: #374151;
  line-height: 1.45;
}

.sm-market-trends-help-item {
  padding: 8px 0;
}

.sm-market-trends-help-item:not(:last-child) {
  border-bottom: 1px solid #e5e7eb;
}

.sm-market-trends-help-item-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.sm-market-trends-help-item-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: #1f2937;
}

.sm-market-trends-help-item-desc {
  margin: 0 0 6px;
  font-size: 0.78rem;
  color: #4b5563;
  line-height: 1.45;
}

.sm-market-trends-help-item-ranges {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 0.74rem;
  font-weight: 500;
}

.sm-market-trends-help-range.buyer {
  color: #3b82f6;
}

.sm-market-trends-help-range.balanced {
  color: #64748b;
}

.sm-market-trends-help-range.seller {
  color: #ea580c;
}

.sm-market-trends-segment-btn {
  padding: 6px 14px;
  font-size: 0.8rem;
  font-weight: 500;
  border: 1px solid #d1d5db;
  background: white;
  color: #374151;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
}

.sm-market-trends-segment-btn:hover {
  border-color: #9ca3af;
}

.sm-market-trends-segment-btn.active {
  background: #111827;
  border-color: #111827;
  color: white;
}

.sm-market-trends-main-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
}

.sm-market-trends-controls {
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.sm-market-trends-checkbox-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  font-size: 0.85rem;
  color: #1f2937;
  cursor: pointer;
  user-select: none;
  background: #fff;
}

.sm-market-trends-checkbox-item:nth-child(even) {
  background: #f9fafb;
}

.sm-market-trends-checkbox-item:not(:last-child) {
  border-bottom: 1px solid #e5e7eb;
}

.sm-market-trends-checkbox-item input[type="checkbox"] {
  margin: 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
}

.sm-market-trends-swatch {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
}

.sm-market-trends-checkbox-label {
  flex: 1;
}

.sm-market-trends-canvas-container-main {
  height: 300px;
  position: relative;
}

.sm-market-trends-empty {
  padding: 32px 16px;
  text-align: center;
  color: #6b7280;
  font-size: 0.85rem;
}

@media (max-width: 640px) {
  .sm-market-trends-canvas-container-main {
    height: 240px;
  }
}
`;
export function injectStyles() {
    if (stylesInjected)
        return;
    const styleEl = document.createElement('style');
    styleEl.id = 'sm-market-trends-styles';
    styleEl.textContent = STYLES;
    document.head.appendChild(styleEl);
    stylesInjected = true;
}
//# sourceMappingURL=styles.js.map